/**
 * Validates formula for unknown attributes and sets Monaco markers.
 *
 * @param {object} monaco - Monaco instance
 * @param {object} model - Monaco model
 * @param {Array} attributeList - List of all available attributes
 */
export const validateFormulaAttributes = (
  monaco,
  model,
  attributeList = []
) => {
  if (!monaco || !model) {
    return;
  }
  const value = model.getValue();
  const markers = [];

  // Create a map of attribute names for efficient lookup
  const attributeMap = new Map(
    attributeList?.map((attr) => [attr?.name, attr])
  );

  // Validate attributes with the new syntax {{attributes.attribute name}}
  const attributeRegex = /\{\{\s*attributes\.([^{}]*?)\s*\}\}/g;
  let match;
  while ((match = attributeRegex.exec(value))) {
    const attrName = match[1].trim();

    // Skip validation for complex formulas containing dots (e.g., source_association.attributes.pp)
    // This is added for association attributes itself formula
    if (attrName.includes('.')) {
      continue;
    }

    if (!attributeMap.has(attrName)) {
      markers.push({
        severity: monaco.MarkerSeverity.Error,
        message: `Unknown attribute: ${attrName}`,
        startLineNumber: model.getPositionAt(match.index).lineNumber,
        startColumn: model.getPositionAt(match.index).column,
        endLineNumber: model.getPositionAt(match.index + match[0].length)
          .lineNumber,
        endColumn: model.getPositionAt(match.index + match[0].length).column,
      });
    }
  }

  monaco.editor.setModelMarkers(model, 'formula-attribute-validation', markers);
};
